/* Lunara — página de producto dinámica */
(function () {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const DAY = 86400000;
  const fmt = (d) => d.toLocaleDateString('es-CO', { weekday: 'short', day: 'numeric', month: 'short' }).split('.').join('');

  function addBusinessDays(base, n) {
    const d = new Date(base);
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++;
    }
    return d;
  }

  $$('[data-product]').forEach((wrap) => {
    let variants = [];
    try { variants = JSON.parse(($('[data-variants]', wrap) || {}).textContent || '[]'); } catch (e) { variants = []; }
    const idInput = $('input[name="id"]', wrap);
    const stockEl = $('[data-pd-stock]', wrap);
    const etaEl = $('[data-pd-eta]', wrap);
    const mainImg = $('.js-main-image', wrap);
    const unitLabel = stockEl && stockEl.dataset.unit === 'talla' ? 'de esta talla' : 'de este diseño';

    const current = () => {
      const id = idInput ? String(idInput.value) : '';
      return variants.find((v) => String(v.id) === id) || variants[0];
    };

    function paintStock() {
      if (!stockEl) return;
      const v = current();
      if (!v || !v.available || !v.tracked || v.inventory <= 0) { stockEl.hidden = true; return; }
      if (v.inventory <= 10) {
        const pct = Math.max(12, Math.round((v.inventory / 10) * 100));
        stockEl.innerHTML = '🔥 ¡Quedan solo <strong>' + v.inventory + '</strong> ' + (v.inventory === 1 ? 'unidad' : 'unidades') + ' ' + unitLabel + '!<span class="pd-stock__bar"><i style="width:' + pct + '%"></i></span>';
        stockEl.classList.add('is-low');
      } else {
        stockEl.innerHTML = '<span class="pd-dot"></span> Disponible ahora';
        stockEl.classList.remove('is-low');
      }
      stockEl.hidden = false;
    }

    $$('[data-option]', wrap).forEach((sel) => sel.addEventListener('change', () => setTimeout(paintStock, 0)));
    paintStock();

    if (etaEl) {
      const min = parseInt(etaEl.dataset.min, 10) || 2;
      const max = parseInt(etaEl.dataset.max, 10) || 6;
      const now = new Date();
      etaEl.innerHTML = '📦 Pídelo hoy y recíbelo aprox. entre el <strong>' + fmt(addBusinessDays(now, min)) + '</strong> y el <strong>' + fmt(addBusinessDays(now, max)) + '</strong>';
      etaEl.hidden = false;
    }

    if (mainImg) {
      const clear = () => mainImg.classList.remove('pd-fade');
      mainImg.addEventListener('load', clear);
      new MutationObserver(() => {
        mainImg.classList.add('pd-fade');
        setTimeout(() => { if (mainImg.complete) clear(); }, 450);
      }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }
  });

  /* Días que faltan para Halloween (sobre la foto) */
  $$('[data-pd-hwdays]').forEach((badge) => {
    const end = new Date(badge.dataset.date + 'T00:00:00-05:00');
    if (isNaN(end.getTime())) return;
    const days = Math.ceil((end.getTime() - Date.now()) / DAY);
    if (days < 1) return;
    badge.innerHTML = days === 1 ? '🎃 ¡Falta <b>1</b> día para Halloween!' : '🎃 Faltan <b>' + days + '</b> días para Halloween';
    badge.hidden = false;
  });

  /* Cuenta regresiva para recibir antes de Halloween */
  $$('[data-pd-countdown]').forEach((box) => {
    const cutoff = new Date(box.dataset.cutoff + 'T23:59:59-05:00');
    if (isNaN(cutoff.getTime())) return;
    const end = new Date((box.dataset.end || '') + 'T00:00:00-05:00');
    const live = $('[data-pd-cd-live]', box);
    const after = $('[data-pd-cd-after]', box);
    const label = $('[data-cutoff-label]', box);
    if (label) label.textContent = cutoff.toLocaleDateString('es-CO', { day: 'numeric', month: 'long', timeZone: 'America/Bogota' });
    const el = { d: $('[data-d]', box), h: $('[data-h]', box), m: $('[data-m]', box), s: $('[data-s]', box) };
    const pad = (n) => String(n).padStart(2, '0');
    let timer = null;
    function tick() {
      const now = Date.now();
      const diff = cutoff.getTime() - now;
      if (diff <= 0) {
        if (timer) clearInterval(timer);
        if (after && !isNaN(end.getTime()) && now < end.getTime()) {
          if (live) live.hidden = true;
          after.hidden = false;
          box.hidden = false;
        } else {
          box.hidden = true;
        }
        return;
      }
      el.d.textContent = pad(Math.floor(diff / DAY));
      el.h.textContent = pad(Math.floor((diff % DAY) / 3600000));
      el.m.textContent = pad(Math.floor((diff % 3600000) / 60000));
      el.s.textContent = pad(Math.floor((diff % 60000) / 1000));
      box.hidden = false;
    }
    tick();
    if (!box.hidden && cutoff.getTime() > Date.now()) timer = setInterval(tick, 1000);
  });
})();
